import { assets } from '@/ui/assets'
import { Button } from '@/ui/atoms/button/Button'
import { Panel } from '@/ui/atoms/panel/Panel'

interface ConnectWalletPanelProps {
  openConnectWalletModal: () => void
}

export function ConnectWalletPanel({ openConnectWalletModal }: ConnectWalletPanelProps) {
  return (
    <Panel
      variant="primary"
      spacing="none"
      className="flex flex-col items-center gap-4 p-4 text-center md:gap-5 md:p-12"
    >
      <img src={assets.points.pointsIcon} alt="Points icon" className="size-10" />
      <div className="flex flex-col items-center gap-2 md:gap-3">
        <h5 className="typography-heading-5">Start Earning Points</h5>
        <span className="typography-body-3 text-secondary">Connect your wallet and start collecting points</span>
      </div>
      <Button variant="secondary" onClick={openConnectWalletModal} className="w-[180px]">
        Connect Wallet
      </Button>
    </Panel>
  )
}
